<div class="pinch-zoom-content" [class.pz-dragging]="isDragging">
  <ng-content></ng-content>
</div>

<div class="pz-zoom-control pz-zoom-control-position-bottom pz-zoom">
  @if (isZoomControlOneButton()) {
    <div class="pz-zoom-button pz-zoom-button-in" [class.pz-zoom-button-out]="isZoomedIn" (click)="toggleZoom()"></div>
  }
  @if (isZoomControlTwoButtons()) {
    <div class="pz-zoom-button pz-zoom-button-out" (click)="zoomOut()"></div>
    <div class="pz-zoom-button pz-zoom-button-in" (click)="zoomIn()"></div>
  }
</div>
